import React from "react";
import { motion } from "framer-motion";

interface HoverCardProps {
  children: React.ReactNode;
  className?: string;
  scale?: number;
  shadow?: boolean;
}

const HoverCard: React.FC<HoverCardProps> = ({
  children,
  className = "",
  scale = 1.03,
  shadow = true,
}) => {
  return (
    <motion.div
      className={className}
      whileHover={{
        scale,
        transition: { duration: 0.3, ease: "easeOut" },
      }}
    
      whileTap={{ scale: 0.98 }}
      style={{
         boxShadow: shadow ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      {children}
    </motion.div>
  );
};

export default HoverCard;

